import { isNil, isNaN } from 'lodash-es';
export class DateInputFormatEnforcer {
    constructor(mask, currentValue) {
        this._selectionStart = 0;
        this._selectionEnd = 0;
        this._generatedCursor = 0;
        this._emptyValue = mask;
        this._lastValidValue = currentValue;
    }
    setLastValidValue(value) {
        this._lastValidValue = value;
    }
    beforeInputCheck(inputKey, selectionStart, selectionEnd, dir) {
        if (!this.isValidInput(inputKey) || this.outOfBounds(selectionStart, inputKey)) {
            return false;
        }
        this._selectionStart = selectionStart;
        this._selectionEnd = selectionEnd;
        this._validInputKey = inputKey;
        this._textDirection = dir;
        return true;
    }
    onInput() {
        if (this.isArrowLeft(this._validInputKey)) {
            this.decrementCursor(this._selectionStart);
            return this._lastValidValue;
        }
        if (this.isArrowRight(this._validInputKey)) {
            this.incrementCursor(this._selectionStart);
            return this._lastValidValue;
        }
        let value = this.clean(this._lastValidValue, this._selectionStart, this._selectionEnd);
        if (this.checkIfNumeric(this._validInputKey)) {
            const startIndex = this.checkIfSeparator(value[this._selectionStart])
                ? this._selectionStart + 1
                : this._selectionStart;
            value = DateInputFormatEnforcer.changeCharAt(value, startIndex, this._validInputKey);
            this.incrementCursor(startIndex);
        }
        if (this.isBackspace(this._validInputKey)) {
            value = this.clean(value, this._selectionStart - 1, this._selectionStart);
            this.decrementCursor(this._selectionStart);
        }
        this._lastValidValue = value;
        return value;
    }
    resetValue() {
        this._lastValidValue = this._emptyValue;
    }
    incrementCursor(cursorIndex) {
        this._generatedCursor =
            this._emptyValue.length >= cursorIndex ? cursorIndex + 1 : cursorIndex;
    }
    decrementCursor(cursorIndex) {
        this._generatedCursor = cursorIndex > 0 ? cursorIndex - 1 : cursorIndex;
    }
    getCursorPos() {
        return this._generatedCursor;
    }
    clean(value, from, to) {
        if (from < 0 || to > value.length) {
            return value;
        }
        for (let i = from; i < to; i++) {
            if (!this.checkIfSeparator(value[i])) {
                value = DateInputFormatEnforcer.changeCharAt(value, i, '_');
            }
        }
        return value;
    }
    initial(currentDateStr, mask) {
        if (isNil(currentDateStr) || currentDateStr === '') {
            this._lastValidValue = mask;
            this._selectionStart = 0;
        }
        else {
            const date = new Date(currentDateStr);
            if (!isNaN(date.getTime())) {
                this._lastValidValue = mask;
                this._selectionStart = this._lastValidValue.length;
            }
            else {
                this._lastValidValue = mask;
                this._selectionStart = 0;
            }
        }
        this._emptyValue = mask;
        return this._lastValidValue;
    }
    checkIfNumeric(key) {
        return /^[0-9]$/.test(key);
    }
    checkIfSeparator(key) {
        return key === '/' || key === '-' || key === '.' || key === ' ' || key === ',';
    }
    isValidInput(key) {
        return (this.checkIfNumeric(key) ||
            this.isDelete(key) ||
            this.isBackspace(key) ||
            this.isArrowLeft(key) ||
            this.isArrowRight(key));
    }
    isBackspace(key) {
        return key.toLowerCase() === 'backspace';
    }
    isArrowLeft(key) {
        return key.toLowerCase() === 'arrowleft';
    }
    isArrowRight(key) {
        return key.toLowerCase() === 'arrowright';
    }
    isDelete(key) {
        return key.toLowerCase() === 'delete';
    }
    outOfBounds(index, key) {
        if (index > this._lastValidValue.length) {
            return true;
        }
        return (index === this._lastValidValue.length &&
            !this.isBackspace(key) &&
            !this.isArrowLeft(key));
    }
    static changeCharAt(str, index, char) {
        return str.substring(0, index) + char + str.substring(index + 1);
    }
    emptyDateMask(formatter) {
        return formatter.format(new Date()).replaceAll(/[0-9]/g, '_');
    }
    static firstDiffIndex(currentValue, oldValue) {
        const minLength = Math.min(currentValue.length, oldValue.length);
        for (let i = 0; i < minLength; i++) {
            if (currentValue[i] !== oldValue[i]) {
                return i;
            }
        }
        return -1;
    }
}
